import React, { useState, useEffect } from "react";
import { postContact } from "store/actions/contactActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";

function ContactUs() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.contacts);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [bgLoaded, setBgLoaded] = useState(false);

  const backgroundUrl =
    "https://firebasestorage.googleapis.com/v0/b/nexteats-staging.appspot.com/o/login_11zon.png?alt=media&token=e0a87137-a0e1-416f-9d82-6f9e50663d73";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !message) {
      toast.error("Please fill all required fields!");
      return;
    }
    await dispatch(postContact(name, email, message));
    setEmail("");
    setName("");
    setMessage("");
  };

  useEffect(() => {
    const img = new Image();
    img.src = backgroundUrl;
    img.onload = () => setBgLoaded(true);
  }, []);

  if (!bgLoaded) {
    return (
      <div className="bg-loader d-flex justify-content-center align-items-center min-vh-100">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 main-content-auth mt-5">
      <div className="row w-100 justify-content-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
          <div className="p-4 bg-white shadow-lg">
            <form className="needs-validation" onSubmit={handleSubmit}>
              <h1 className="h4 mb-4 text-left">Get in Touch</h1>

              <div className="form-group position-relative mb-3">
                <label htmlFor="name" className="sr-only">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group position-relative mb-3">
                <label htmlFor="email" className="sr-only">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group position-relative mb-3">
                <label htmlFor="message" className="sr-only">
                  Message
                </label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Your message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                ></textarea>
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button type="submit" className="btn btn-danger px-5">
                  {loading ? <Spinner size="sm" color="light" /> : "Contact Us"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
